import { useTranslation } from "react-i18next";
import "./Information.scss";
import image from "../../assets/castle-background.png";

export default function Information() {
	const { t } = useTranslation();

	return (
		<section id="information" className="section dark information">
			<div className="information__inner">
				{/* IMAGE */}
				<div className="information__media">
					<div className="information__image">
						<img src={image} alt="Revibrain context visual" />
					</div>
				</div>
				{/* TEXT */}
				<div className="information__content">
					<h2>{t("information.title")}</h2>

					<p>{t("information.text")}</p>

					<p className="information__secondary">{t("information.secondary")}</p>
				</div>
			</div>
		</section>
	);
}
